import './edit.scss';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ConfigProvider, message, Select } from 'antd';
import { EditBalancerTransaction } from 'core/domain/balancer-transaction/balancer-transaction';
import { Enum } from 'core/domain';
import { getOrderSides } from 'core/repositories/orders';
import { editBalancerTransaction, getBalancerTransactionById } from 'core/repositories/balancer-transaction';
import { digitSperator, faNumToEnNum } from 'core/utils/decimalExtentions';
import { Page } from 'components/page/page';
import { Input, inputType } from 'components/input/input';
import { Button } from 'components';
import { buttonType } from 'components/button/button';

const initialFilters = {
    side: {
        id: -1,
        title: 'سمت معامله',
    },
};

export const EditBalancerTransactionPage = () => {
    const { id } = useParams<{ id: string }>();
    const [loading, setLoading] = useState<boolean>(false);
    const [editLoading, setEditLoading] = useState<boolean>(false);
    const [formData, setFormData] = useState<EditBalancerTransaction>({
        id: '',
        onPrice: 0,
        amount: 0,
        side: 1,
        symbol: '',
    });
    const [orderSides, setOrderSides] = useState<Enum[]>([initialFilters.side]);

    const navigate = useNavigate();

    useEffect(() => {
        if (id) {
            getBalancerTransactionById(setLoading, id, (data) => {
                setFormData({
                    ...data,
                    onPrice: data.onPrice.toString(),
                    amount: data.amount.toString(),
                });
            });
        }
    }, [id]);

    useEffect(() => {
        getOrderSides(setLoading, setOrderSides);
    }, []);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    return (
        <Page title="ویرایش تراکنش" className="pmx-edit-balancer-transaction" loading={loading}>
            <ConfigProvider theme={{ token: { borderRadius: 20 } }}>
                <Select
                    disabled={loading}
                    loading={loading}
                    value={formData.side}
                    onChange={(value) => setFormData({ ...formData, side: value })}
                    style={{ width: '100%', borderRadius: 20 }}
                >
                    {orderSides.map((item) => (
                        <Select.Option key={item.id} value={item.id}>
                            {item.title}
                        </Select.Option>
                    ))}
                </Select>

                <Select
                    value={formData.symbol}
                    onChange={(value) => setFormData({ ...formData, symbol: value })}
                    style={{ width: '100%', borderRadius: 20 }}
                    placeholder="نماد را انتخاب کنید"
                >
                    <Select.Option value="UUSD">UUSD (یوتوپیا)</Select.Option>
                    <Select.Option value="USDT">USDT (تتر)</Select.Option>
                </Select>
            </ConfigProvider>

            <Input
                type={inputType.text}
                name="onPrice"
                value={digitSperator(faNumToEnNum(formData?.onPrice.toString()))}
                onChange={handleChange}
                label="قیمت:"
                placeholder="قیمت را وارد کنید"
            />

            <Input
                type={inputType.text}
                name="amount"
                value={digitSperator(faNumToEnNum(formData?.amount.toString()))}
                onChange={handleChange}
                label="مقدار:"
                placeholder="مقدار را وارد کنید"
            />

            <Button
                type={buttonType.success}
                loading={editLoading || loading}
                disabled={editLoading || loading || formData.side === -1}
                onClick={() => {
                    editBalancerTransaction(setEditLoading, formData, () => {
                        message.success('تراکنش با موفقیت ویرایش شد.');
                        navigate(-1);
                    });
                }}
                text={'ویرایش تراکنش'}
            />
        </Page>
    );
};
